import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const EditFeedbackCategories = () => {
  const { film_id } = useParams(); // Get the film ID from the URL
  const [feedbackCategories, setFeedbackCategories] = useState([]);
  const [notes, setNotes] = useState(''); // State for filmmaker's notes
  const [availableCategories, setAvailableCategories] = useState([
    'Writing',
    'Cinematography',
    'Editing',
    'Art-Design',
    'Costuming',
    'Sound-Design',
    'Directing',
  ]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to the top of the page when the component loads
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {

    const fetchFilm = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/films/${film_id}/feedback-categories`);
        setFeedbackCategories(response.data.feedback_categories || []);
        setNotes(response.data.notes || ''); // Set notes
      } catch (err) {
        console.error('Error fetching film:', err);
        setError('Failed to fetch film details.');
      }
    };

    fetchFilm();
  }, [film_id]);

  const handleSave = async () => {
    try {
      await axios.patch(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/films/${film_id}/feedback-categories`, {
        feedback_categories: feedbackCategories,
        notes, // Include notes in the payload
      });
      setSuccess('Feedback categories and notes updated successfully!');
      setError('');
      setTimeout(() => navigate('/dashboard'), 2000); // Redirect to dashboard after success
    } catch (err) {
      console.error('Error updating feedback categories and notes:', err);
      setError('Failed to update feedback categories and notes.');
      setSuccess('');
    }
  };

  const toggleCategory = (category) => {
    setFeedbackCategories((prev) =>
      prev.includes(category)
        ? prev.filter((cat) => cat !== category) // Remove category
        : [...prev, category] // Add category
    );
  };

  return (
<div
    style={{
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      color: '#333',
      backgroundColor: '#f0f9f0', // Light greenish tint
      minHeight: '100vh', // Ensures the background covers the full viewport height
    }}
  >      <h1 style={{ textAlign: 'center', color: '#0056b3', marginBottom: '20px' }}>
        Edit Feedback Categories and Notes
      </h1>
      {error && (
        <p style={{ color: 'red', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
          {error}
        </p>
      )}
      {success && (
        <p style={{ color: 'green', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
          {success}
        </p>
      )}
  
      {/* Notes Section */}
      <div style={{ marginBottom: '30px' }}>
        <label>
          <h2 style={{ color: '#0056b3', marginBottom: '10px' }}>Filmmaker's Notes</h2>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="4"
            cols="50"
            placeholder="Add or update notes for reviewers..."
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '16px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          />
        </label>
      </div>
  
      {/* Feedback Categories Section */}
      <div style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#0056b3', marginBottom: '10px' }}>Feedback Categories</h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {availableCategories.map((category) => (
            <li
              key={category}
              style={{
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  checked={feedbackCategories.includes(category)}
                  onChange={() => toggleCategory(category)}
                  style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                  }}
                />
                <span style={{ fontSize: '16px', color: '#333' }}>{category}</span>
              </label>
            </li>
          ))}
        </ul>
      </div>
  
      {/* Action Buttons */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <button
          onClick={handleSave}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#218838')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#28a745')}
        >
          Save Changes
        </button>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#c82333')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#dc3545')}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditFeedbackCategories;